import React, { Component } from "react";
import * as PIXI from "pixi.js";
import UIManager from "../../core/components/ui/UiBuilder";
import { withPixiApp } from "@inlet/react-pixi";
import { GJIStore } from "../../gamestore/IStore";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withGameRulesContainerConfiguration from "./configuration/withGameRulesContainerConfiguration";
import { isMobile } from "react-device-detect";
import { configGame, constant } from "../../data/config";


interface IStore {
    [x: string]: any;
}
interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class GameRulesContainer extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected displayUI: any;
    protected gameRulesContainer: any;
    protected gameRulesComponentContainer: any;
    protected gamerules_component_container: any;
    protected scope: any;
    protected ui_mode: string;
    protected gameRulesComponentList: Array<any>
    private gameGuide: any;
    private gameControl: any;
    private gameGuide_yellow: any;
    private gameGuide_white: any;
    private control_yellow: any;
    private control_white: any;
    private gameGuideBtn: any;
    private controlBtn: any;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.gameRulesContainer = React.createRef();
        this.gameRulesComponentContainer = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en"
        }

        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
        //reel,row
        this.gameRulesComponentList = []
        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this));
    }

    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    bindUI() {
        this.gameGuideBtn = UIManager.getRef("gameGuideBtn");
        this.controlBtn = UIManager.getRef("controlBtn");
        this.gameGuide_yellow = UIManager.getRef("gameGuideCont_yellow");
        this.gameGuide_white = UIManager.getRef("gameGuideCont_white");
        this.control_yellow = UIManager.getRef("controlsCont_yellow");
        this.control_white = UIManager.getRef("controlsCont_white");
        this.gameGuide = UIManager.getRef("gameGuideComponent");
        this.gameControl = UIManager.getRef("gameControlComponent");

        this.gameGuide.visible = true;
        this.gameControl.visible = false;
    }

    showGameGuide() {
        this.control_yellow.visible = false;
        this.control_white.visible = true;
        this.gameGuide_yellow.visible = true;
        this.gameGuide_white.visible = false;

        this.gameGuide.visible = true;
        this.gameControl.visible = false;
    }

    showControls() {
        this.control_yellow.visible = true;
        this.control_white.visible = false;
        this.gameGuide_yellow.visible = false;
        this.gameGuide_white.visible = true;

        this.gameGuide.visible = false;
        this.gameControl.visible = true;
    }

    handleEvent = (e: any) => {
        switch (e.target.name) {
            case "gameGuideBtn":
                this.showGameGuide();
                break;
            case "controlBtn":
                this.showControls();
                break;

            default:
                return 'No buttons';
        }
        //alert("handleEvent")
    }
    mouseOver() {
        //alert("mouseOver")
    }
    mouseOut() {
        //alert("mouseOut")
    }

    componentDidMount() {
        this.bindUI();
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.showSettingGameRules !== this.props.showSettingGameRules) {
            if (nextProps.showSettingGameRules) {
                this.gameRulesContainer.COMPONENT.visible = true;
            } else {
                this.gameRulesContainer.COMPONENT.visible = false;
            }
            return false;
        }
        return true;
    }
    render() {

        return (<UIManager id={"gameRulesContainer"} name={"gameRulesContainer"} type={"Container"}
            ref={i => this.gameRulesContainer = i}
            x={0} y={0} visible = {false}>
            {
                this.displayUI && this.displayUI.map((i: any) =>
                    <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type} 
                        id={i.id} {...i} app={this.app} ClickHandler={this.handleEvent} mouseOver={this.mouseOver} mouseOut={this.mouseOut} />)
            }
        </UIManager>)
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'behaviourState'>): IStateToProps =>
    ({
        showSettingGameRules: state.behaviourState.showSettingGameRules
    }),
    (dispatch: Dispatch): IDispatchToProps => ({

    }))(withGameRulesContainerConfiguration(GameRulesContainer)));